import React, { useEffect, useState } from "react";
import { Typography, Button, Row, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";

const { Title } = Typography;

function Backlogs() {

  const navigate = useNavigate();
  const { projectId } = useParams();

  const [tasks, setTasks] = useState([]);
  const [project, setProject] = useState(null);

  useEffect(() => {

    const token = localStorage.getItem("access-token");

    const fetchTasks = async () => {

      try {

        const res = await fetch(
          `https://rhrmapi.up2dateinc.com/api/tasks/project/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = await res.json();

        if (Array.isArray(data)) {
          setTasks(data);
        } else {
          setTasks([]);
        }

      } catch (error) {

        message.error("Failed to load tasks");

      }

    };

    const fetchProject = async () => {

      try {

        const res = await fetch(
          `https://rhrmapi.up2dateinc.com/api/projects/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = await res.json();

        setProject(data);

      } catch (error) {

        message.error("Failed to load project");

      }

    };

    if (projectId) {
      fetchTasks();
      fetchProject();
    }

  }, [projectId]);

  return (
    <div>

      <Row justify="space-between" align="middle">
        <Title level={3}>
          Backlogs {project ? `- ${project.projectName}` : ""}
        </Title>

        <div>

          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() =>
              navigate(`/admin/create-task/${projectId}`)
            }
          >
            Create Task
          </Button>

          <Button
            style={{ marginRight: 10 }}
            onClick={() =>
              navigate(`/admin/manage-backlog/${projectId}`)
            }
          >
            Manage Backlog
          </Button>

          <Button
            onClick={() =>
              navigate(`/admin/transfer-task/${projectId}`)
            }
          >
            Transfer Task
          </Button>

        </div>
      </Row>

      <p style={{ marginTop: 20 }}>
        Total Tasks : <b>{tasks.length}</b>
      </p>

    </div>
  );
}

export default Backlogs;